import React = require("react");
import { ToolbarContext } from "./ToolbarContextProvider";
import styleable from "react-styleable";
import * as styles from '../../../css/components/toolbar/Toolbar.css';

class Toolbar extends React.Component<any, any>{
    render() {
        return <ToolbarContext.Consumer>
            {v => {
                return <div className={this.props.css.toolbar}>
                    {v.toolbarItems.map((ti, i) => <span key={i} className={(i === 0 ? this.props.css.first : "") + " " + (i === v.toolbarItems.length-1 ? this.props.css.last : "")}>{ti}</span>)}
                </div>
            }}
        </ToolbarContext.Consumer>;
    }
}
export default styleable(styles)(Toolbar);